var React = require('react');

function CarouselLeft (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#222A35;}\n"),React.createElement("g",{"id":"V4","key":1},React.createElement("g",{"id":"TB_Website_Desktop_Work_WStore","transform":"translate(-1345.000000, -3990.000000)"},React.createElement("g",{"id":"Gallery","transform":"translate(38.000000, 3672.000000)"},React.createElement("path",{"id":"Line-2-Copy-4","className":"st0","d":"M1334.4,322.4l-15.1,8.5l36.3-0.1l0,4l-36.3,0.1l15.1,8.5l-2,3.5l-24.9-13.9l24.8-14\n\t\t\t\tL1334.4,322.4z"}))))]);
}

CarouselLeft.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 49 29","style":{"enableBackground":"new 0 0 49 29"},"xmlSpace":"preserve"};

module.exports = CarouselLeft;

CarouselLeft.default = CarouselLeft;
